module.exports = __webpack_public_path__ + "static/other-b3ad6dd9f7800aabcc26ee6eda81ecc3.png";